import React, { useState } from 'react';
import '../App.css';

const faqs = [
  {
    question: 'What services do you offer?',
    answer:
      'We provide a full range of professional cleaning services including residential, commercial, Airbnb, carpet, and after-builder cleaning — all using eco-friendly, non-toxic products.',
  },
  {
    question: 'Do you guarantee your work?',
    answer:
      'Yes. We stand by our services with a 100% satisfaction guarantee. If something\'s not right, we’ll come back and fix it — no questions asked. (Please contact us within 48h)',
  },
  {
    question: 'Can I book your services online?',
    answer:
      'Yes, we offer easy online booking and free quotes through our website. You can also call or email us directly to arrange a time that suits you.',
  },
  {
    question: 'Do you bring your own equipment and supplies?',
    answer:
      'Yes, our team comes fully equipped with professional-grade tools and eco-friendly cleaning products. You don’t need to provide anything.',
  },
  {
    question: 'Do I need to be home during the clean?',
    answer:
      'Not at all. As long as we have access, our trusted team can carry out the job while you\'re away. We’ll communicate clearly before and after every clean.',
  },
  {
    question: 'Do you service my area?',
    answer:
      'We are based in Auckland and service Auckland-wide. If you\'re just outside the city, get in touch and we’ll let you know if we can accommodate your location.',
  },
  {
    question: 'Can I customise a service package?',
    answer:
      'Absolutely. We offer flexible, tailored cleaning packages to suit your exact needs and budget.',
  },
];

const FAQs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleIndex = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="faq_page">
      <h2><span>Frequently</span> Asked Questions</h2>
      <p className="faq_intro">We’re here to help. If you don’t find what you’re looking for, please <a href="mailto:info@luxesparkle.co.nz?subject=Support Request" >contact us</a>
      .</p>

      <div className="faq_list">
        {faqs.map((item, idx) => (
          <div className="faq_item" key={idx}>
            <button className="faq_question" onClick={() => toggleIndex(idx)}>
              {item.question}
              <span className="toggle_icon">{activeIndex === idx ? '-' : '+'}</span>
            </button>
            {activeIndex === idx && <p className="faq_answer">{item.answer}</p>}
          </div>
        ))}
      </div>

      <div className="faq_vision">
        <h4>Luxe Sparkle Vision</h4>
        <p>
          "To lead New Zealand’s cleaning industry by setting the gold standard in customer care,
          sustainability, and ethical cleaning solutions."
        </p>
      </div>
    </div>
  );
};

export default FAQs;
